import { SafeUrl } from '@angular/platform-browser';

export class PageFile {
  file: File;
  url: SafeUrl;

  constructor(clone: PageFile = null) {
    this.file = null;
    this.url = '';

    if (clone) {
      this.file = clone.file;
      this.url = clone.url;
    }
  }
}
